import { closeClientContactModal } from '../State/clientContactModal'

export default () => (dispatch) => {

  dispatch(closeClientContactModal())

}
